<template>
    <transition name="modal-fade">
        <div id="modalEditBanner" class="dibble-modal modal-account-verification" style="z-index: 9999">
            <div class="modal small-m">
                <div
                    class="modal-dialog modal-form "
                    role="document"
                    style="width: 600px"
                >
                    <div class="modal-content" style="min-width: 600px !important;">
                        <div class="modal-header">
                            <p class="title-modal">
                <span class="distribute-title">
                  Distribute Campaign
                </span>
                            </p>
                            <button
                                type="button"
                                data-dismiss="modal"
                                aria-label="Close"
                                @click="closeModal"
                            >
                                <img src="@/assets/images/close-dialog.svg" alt="close-icon">
                            </button>
                        </div>
                        <div class="modal-body form-box mt-2">
                            <div class="user-modal-content" style="overflow: visible">
                                <div class="text-left">
                                    <p>
                                        After analyzing your file, we found:
                                    </p>
                                    <div class="distribution-data">
                                        <div class="data-row">
                                            <div class="left" v-text="data.total_entries"></div>
                                            <div class="right">Total entries</div>
                                        </div>
                                        <div class="data-row">
                                            <div class="left" v-text="data.named_entries"></div>
                                            <div class="right">Named recipients</div>
                                        </div>
                                        <div class="data-row">
                                            <div class="left" v-text="data.unnamed_entries"></div>
                                            <div class="right">Unamed recipients</div>
                                        </div>
                                        <div class="data-row">
                                            <div class="left" v-text="data.email_addresses"></div>
                                            <div class="right">Email addresses</div>
                                        </div>
                                        <div class="data-row">
                                            <div class="left" v-text="data.phone_numbers"></div>
                                            <div class="right">Phone numbers</div>
                                        </div>
                                        <div class="data-row">
                                            <div class="left"
                                                 v-text="data.invalid_email_addresses"
                                                 :class="data.invalid_email_addresses > 0 ? 'text-danger' : 'text-muted'"></div>
                                            <div class="right" :class="data.invalid_email_addresses > 0 ? 'invalid' : ''">
                                                <span :class="data.invalid_email_addresses > 0 ? 'text-danger' : 'text-muted'">Invalid email addresses</span>
                                                <span v-if="data.invalid_email_addresses > 0">
                                                    <a target="_blank" :href="data.invalid_entries_download_url">Download Error Report</a>
                                                </span>
                                            </div>
                                        </div>
                                        <div class="data-row">
                                            <div class="left"
                                                 v-text="data.invalid_phone_numbers"
                                                 :class="data.invalid_phone_numbers > 0 ? 'text-danger' : 'text-muted'"
                                            ></div>
                                            <div class="right"  :class="data.invalid_phone_numbers > 0 ? 'text-danger' : 'text-muted'">Invalid Phone numbers</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div>
                                <div class="d-flex justify-content-center mt-5">
                                    <button v-text="'Distribute'"
                                            class="btn-dialog btn-sm ok-btn mr-2 distribution-upload-btn" @click="distributeCampaign">
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
import DibbleJS from "@/dibble";
import DibbleAPI from "@/api";

export default {
    name: "ModalCampaignDistributionProgress",
    props: {
        data: Object,
    },
    methods: {
        distributeCampaign() {
            DibbleJS.showLoader()
            DibbleJS.callApiRequest({
                '#request': DibbleAPI.api.distributionDistribute,
                distribution_id: this.data.distribution_id,
            }, (response) => {
                DibbleJS.hideLoader()
                if (DibbleAPI.isResponseSuccess(response)) {
                    this.$emit("distribute-success");
                    this.closeModal()
                } else {
                    this.$emit("distribute-error");
                }
            })
        },
        closeModal() {
            this.$emit("close");
        },
    },
};
</script>

<style lang="scss" scoped>
.modal-content {
    min-width: 500px !important;
}

.modal-content, .modal-body {
    background: #EDF5F7 !important;
    border-radius: 60px !important;
    padding: 10px 20px;
}

.modal-header {
    display: flex !important;
    justify-content: space-between !important;
    align-items: center;
    padding: 10px 0px !important;
    border-bottom: 1.5px solid #1C5169;
    margin: 0 20px !important;

    .title-modal {
        font-family: 'Open Sans';
        font-style: normal;
        font-weight: 700;
        font-size: 22px;
        line-height: 22px;
        letter-spacing: 0.01em;
        color: #1C5169;
        margin-top: 0 !important;
    }

    button {
        border: none !important;
        outline: none !important;
        background: initial;
    }
}

.user-modal-content {
    max-height: 500px;
    overflow: scroll;
}

.btn-dialog.btn-sm {
    font-size: 14px;
    height: 40px;
}
.distribute-title {
    color: #2178AB;
}
.distribute-section {
    display: flex;
    flex-direction: row;
    margin-bottom: 25px;

    .section-number {
        background: #7BBDEF;
        color: #FFFFFF;
        width: 44px !important;
        height: 40px;
        margin-right: 20px;
        border-radius: 50%;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 28px;
        font-weight: 700;
    }

    .section-content {
        display: flex;
        flex-direction: column;
        text-align: left;
        color: #555E67;
        font-size: 18px;
        width: 100%;

        ol {
            margin: 0;
            padding-left: 20px;
            font-size: 16px;
        }

    }
}
.distribute-btn {
    font-family: 'Open Sans';
    border-radius: 20px;
    background: #d9d9d9;
    box-shadow: 0px 13px 30px -12px rgba(0, 0, 0, 0.25);
    font-size: 20px;
    font-weight: 700;
    width: 280px;
    color: #555E67;
    line-height: 150%;
    margin-top: 10px;
    float: none;
}
.distribution-upload-btn {
    width: 160px;
    padding-top: 10px;
    padding-bottom: 10px;
    height: 60px !important;
    border-radius: 20px;
    font-size: 20px !important;
}
.distribution-data {

    .data-row {
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        margin-bottom: 10px;
        color: #555E67;

        .left {
            font-weight: 500;
            width: 60px;
            text-align: right;
            padding-right: 5px;
        }

        .right {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: flex-start;

            a {
                color: #2178AB;
                text-decoration: underline;
            }
            width: 100%;

            &.invalid {
                display: flex;
                flex-direction: row;
                justify-content: space-between;
                align-items: center;
            }


        }

        .text-muted {
            color: #C4C4C5 !important;
        }
    }
}
</style>
